class GoogleAnalyticsMetaDataObj {
    constructor(accountID, isLoggedIn, regStatus) {
        this.account_balance = 'null'; //
        this.account_id = isLoggedIn ? accountID : '123456'; //
        this.aff_id = 'null'; // out of scope
        this.bid = 'null'; // out of scope
        this.brand = 'sbg'; //
        this.btag = 'null'; //
        this.city = 'null'; // out of scope
        this.clkid = 'null'; // out of scope
        this.connection_type = 'null'; // out of scope
        this.country = 'null'; // out of scope
        this.currency = 'null'; // out of scope
        this.efid = 'null'; // out of scope
        this.jurisdiction = 'uki'; //
        this.language = 'en_en'; //
        this.locale = 'en_gb'; //
        this.login_status = isLoggedIn ? 'logged in' : 'logged out'; //
        this.mi_ign = 'null'; //
        this.mi_u = 'null'; //
        this.orientation = GoogleAnalyticsMetaDataObj.setOrientation(
            window.navigator
        ); //
        this.pi = 'null'; // out of scope
        this.pid = 'null'; // out of scope
        this.product = 'web'; //
        this.product_theme = 'null'; // out of scope
        this.promo_code = 'null'; //
        this.reg_status = GoogleAnalyticsMetaDataObj.setRegStatus(
            isLoggedIn,
            regStatus
        ); //
        this.rfr = 'null'; //
        this.sid = 'null'; // out of scope
        this.sub_id = 'null'; //
        this.context = 'itv7';
        this.ttp = 'null'; // out of scope
        this.user_id = isLoggedIn ? accountID : null; //
        this.vertical = 'sports';
    }

    static setOrientation(navigator) {
        const isOnAndroid = navigator.userAgent.includes('Android');
        const isOnIosWeb = navigator.userAgent.includes('iPhone');
        const isIpad = navigator.userAgent.includes('iPad');
        if (isOnAndroid || isOnIosWeb || isIpad) {
            return window.outerWidth / window.outerHeight > 1
                ? 'landscape'
                : 'portrait';
        }
        return 'desktop';
    }

    static setRegStatus(isLoggedIn, regStatus) {
        if (isLoggedIn) {
            return regStatus ? 'part reg' : 'full reg';
        }

        return 'null';
    }
}

export default GoogleAnalyticsMetaDataObj;
